<div
    *ngIf="curriculumManagementData != undefined && curriculumManagementData.lists.length >= 0 && !spinnerOn && isScopeSelected">
    <div class="curriculumPanelList" id="curriculumPanelList">
        <app-panel-list [panelList]="curriculumManagementData" [noResultFound]="noData" [showLoader]="showPanelLoader"
            (selectedItems)="getSelectedItems($event)" [ifAdditionalItems]="true">
            <span class="additional-items">
                <p-checkbox class="col p-0 pr-2" name="showRemovedTrainingItems" value="all" [(ngModel)]="showAll"
                    [binary]="true" (onChange)="checkboxSelection($event)"></p-checkbox>
                <app-label labelText="Show All"></app-label>
                <i class="fa fa-info-circle ml-2 info-icon-color" aria-hidden="true"
                    pTooltip="{{ informationIconTooltip }}"></i>
            </span>
            <ng-template #templateRef let-data="dataVar">
                <div panel-content class="grid curriculumPanelCards">
                    <div class="col-5 m-0 p-0 curriculumOverflow">
                        <div class="grid p-0 m-0">
                            <div class="col flex-initial curriculumOverflow pl-1">
                                <app-label labelText="Training Item"></app-label>
                                <div *ngIf="data?.type == 0">
                                    <a class="overflow-ellipse flex-initial flex underline text-primary"
                                        style="cursor: pointer;" (click)="openDocument(data?.number,data?.version)">
                                        <app-read-only
                                            readonlyText="{{ data?.number }} {{data?.title}} (v{{ data?.version }})"
                                            toolTipMessage="{{ data?.number }} {{data?.title}} (v{{ data?.version }})"></app-read-only>
                                    </a>
                                </div>
                                <div *ngIf="data?.type == 1">
                                    <a class="overflow-ellipse flex-initial flex underline text-primary"
                                        style="cursor: pointer;" (click)="openCourse(data?.number)">
                                        <app-read-only readonlyText="{{ data?.number }} {{data?.title}}"
                                            toolTipMessage="{{ data?.number }} {{data?.title}}"></app-read-only>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 curriculumOverflow text-left">
                        <app-label labelText="Type"></app-label>
                        <app-read-only readonlyText="{{ data?.typeName }}"></app-read-only>
                    </div>
                    <div class="col-2 curriculumOverflow text-left">
                        <app-label labelText="Training Item Group"></app-label>
                        <div class="content-wrap" *ngFor="let tigName of data?.trainingItemGroupNames">
                            <app-read-only readonlyText="{{ tigName }}"></app-read-only>
                        </div>
                    </div>
                    <div class="col text-left">
                        <app-label labelText="Status"></app-label>
                        <div class="grid p-0">
                            <div class="col max-w-0 p-0">
                                <em class="pi pi-circle-fill" [ngClass]="{
                        active: data?.status == 'Active',
                        inactive: data?.status == 'Removed',
                        scheduled:data?.status == 'Scheduled'
                        }"></em>
                            </div>
                            <div class="col ml-1 p-0 pl-3">
                                <app-read-only readonlyText="{{ data?.status }}"></app-read-only>
                            </div>
                        </div>
                    </div>
                    <div class="col curriculumOverflow text-left">
                        <app-label labelText="Core/Elective"></app-label>
                        <app-read-only readonlyText="{{ data?.coreOrElective }}"></app-read-only>
                    </div>
                </div>
            </ng-template>
        </app-panel-list>
    </div>
    <div class="grid btnClass p-0 mt-5" *ngIf="buttonsShouldBeDisplayed">
        <div class="col-fixed" style ="width: 15%;">
            <p-splitButton class="p-splitbutton-menubutton splitBtn" label="Core/Elective" [model]="coreOrElective"
                [disabled]="!ifItemsAreSelected"></p-splitButton>
        </div>
        <div class="col-fixed" style ="width: 12%;">
            <p-splitButton class="p-splitbutton-menubutton splitBtn status" label="Status" [model]="statuses"
                [disabled]="!ifItemsAreSelected"></p-splitButton>
        </div>
        <div class="col">
            <p-button appPreventDoubleClick label="{{ unAssignTrainingItemGroupBtnLabel }}" type="submit"
                id="unAssignTrainingItemGroupsBtn" (debounceClick)="openUnAssignTrainingItemGroupSlider()">
            </p-button>
        </div>
    </div>
</div>

<app-unassign-training-item-group-slider
  *ngIf="isUnAssignTrainingItemGroupSliderOpen"
  [isUnAssignTrainingItemGroupSliderOpen]="isUnAssignTrainingItemGroupSliderOpen"
  (isUnAssignTrainingItemGroupSliderActive)="closeUnAssignTrainingItemGroupSlider($event)"
  (refreshOnUnAssignTrainingItemGroups)="refreshCurriculumOnUnAssignTrainingItemGroups($event)"
  (selectedTrainingItemGroupsList)="selectedTrainingItemGroupsList($event)"
  (unassignTrainingItemGroups)="unAssignTrainingItemGroupsFromCurriculum()"
  [trainingItemGroups]="trainingItemGroups"
  [curriculumScopeId]="curriculumScopeId"
></app-unassign-training-item-group-slider>